const CameraIcon = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.95661 17.4115H19.7501C20.9042 17.4115 21.8493 16.4461 21.8493 15.2673V5.61833C21.8493 4.43949 20.9042 3.47412 19.7501 3.47412H17.2306C16.8842 3.47412 16.511 3.1999 16.4026 2.86374L15.7509 0.867958C15.641 0.532033 15.2688 0.257812 14.9224 0.257812H7.78426C7.4379 0.257812 7.06471 0.532033 6.95602 0.868197L6.30434 2.86398C6.19471 3.20014 5.82269 3.47436 5.47633 3.47436H2.95661C1.80252 3.47436 0.857422 4.43973 0.857422 5.61857V15.2673C0.857422 16.4461 1.80252 17.4115 2.95661 17.4115Z"
        fill="white"
      />
      <circle
        cx="11.3731"
        cy="9.81154"
        r="3.9717"
        stroke="#FF6600"
        strokeWidth="3"
      />
      <circle cx="19.9834" cy="6.02149" r="0.841799" fill="#FF6600" />
    </svg>
  );
};

export default CameraIcon;
